export const SET_DATA_NEW_USER_STATE = "@@app/SET_DATA_NEW_USER_STATE";
export const SET_NEW_USER = "@@app/SET_NEW_USER";
export const RESET_DATA_NEW_USER = "@@app/RESET_DATA_NEW_USER";
export const SET_STATE_USER_SETTINGS = "@@app/SET_STATE_USER_SETTINGS";
